<div
  [ngClass]="
    display ? 'skymiles-landing-page-onboarding skymiles__container--gap' : ''
  "
  *ngIf="display"
>
  <a
    class="skymiles-landing-page-onboarding__close"
    (click)="display = false"
    (keydown.enter)="display = false"
    href="javascript:void(0);"
    role="button"
  >
    <span class="sr-only">{{ content.ariaLabel.close }}</span>
  </a>
  <div class="skymiles-landing-page-onboarding__title">{{ content.title }}</div>
  <div class="skymiles-landing-page-onboarding__subtitle">
    {{ content.subtitle }}
  </div>
  <div class="skymiles-landing-page-onboarding__label">{{ content.label }}</div>
  <div class="skymiles-landing-page-onboarding__content">
    <div
      class="skymiles-landing-page-onboarding__items"
      *ngFor="let item of content.items"
    >
      <div class="skymiles-landing-page-onboarding__data">
        <div class="skymiles-landing-page-onboarding__data-details">
          <idp-image
            class="skymiles-landing-page-onboarding__item-icon"
            [content]="item.logo"
          ></idp-image>
          <div class="skymiles-landing-page-onboarding__item-data">
            <div class="skymiles-landing-page-onboarding__item-details">
              <h5 class="skymiles-landing-page-onboarding__item-title">
                {{ item.title }}
              </h5>
              <h6 class="skymiles-landing-page-onboarding__item-desc">
                {{ item.description }}
              </h6>
            </div>
          </div>
        </div>
        <div class="skymiles-landing-page-onboarding__item-content">
          <h5 class="skymiles-landing-page-onboarding__item-title">
            {{ item.title }}
          </h5>
          <h6 class="skymiles-landing-page-onboarding__item-desc">
            {{ item.description }}
          </h6>
          <idp-link
            *ngIf="item.link"
            [label]="item.link.label"
            [axLabel]="item.axLink"
            (click)="redirect(item.link.url)"
            class="skymiles-landing-page-onboarding__link"
            [labelSize]="'large'"
            idpOpenNewWindow
          ></idp-link>
        </div>
      </div>
      <div class="skymiles-landing-page-onboarding__border"></div>
    </div>
  </div>
  <div
    *ngIf="content.action.label"
    class="skymiles-landing-page-onboarding__confirmation"
  >
    <idp-button
      (click)="display = false"
      [label]="content.action.label"
      [size]="buttonSize"
      [type]="'secondary'"
      ariaLabel="Skymiles Onboarding Close"
      [ariaPopup]="false"
    ></idp-button>
  </div>
</div>
